module.exports = __webpack_public_path__ + "static/media/DSC00777.3c1b6016.jpg";